<template>
  <div>
    <navigator :title="serviceName"></navigator>
    <ServiceRate :score="score" :totalScoreNum="totalScoreNum" class="rate"></ServiceRate>
    <div class="content">
      <!-- 富文本 -->
      <div class="text" ref="text" v-html="content" v-show="formType !== 2"></div>
      <!-- 表单 -->
      <CustomForm :formObj="formInfo" v-if="formType === 2" @finishForm="submitForm"></CustomForm>

      <div v-if="detalisInfo.serviceQrcodeList">
        <QrcodeQuickEntry :serviceQrcodeList="detalisInfo.serviceQrcodeList"></QrcodeQuickEntry>
      </div>

    </div>
    <div class="footer-fixed">
      <mt-button class="footer-btn" @click.native="booking" v-if="formType !== 2">申 请</mt-button>
    </div>

    <!-- 模态 -->
    <div class="modal" v-show='modalShow'>
      <div class="close" @click="modalShow=false">
        <van-icon name="close" />
      </div>
      <div class="container">
        <CustomForm :formObj="formInfo" v-if="formType === 3" :showModal="modalShow" @finishForm="submitForm"></CustomForm>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import { jsTimestampFilter } from '@/utils/filters.js';
import { Indicator, Toast } from 'mint-ui';
import deepcopy from '@/utils/deepcopy';
import QrcodeQuickEntry from '@/components/QrcodeQuickEntry';

export default {
  data() {
    return {
      star: 3,
      serviceId: 0,
      serviceName: '',  // 服务名称
      content: '',  // 富文本
      formType: 0,    // 1为文本， 2为表单 3为文本+表单
      formInfo: {},   // 表单内容
      modalShow: false,
      serviceType: 0,
      totalScoreNum: 0,//总评价人数
      score: 0,//平均评分
      user: '',
      serviceMsg: {},
      submitting: false,
      detalisInfo: {},
      mobile:'',
      userId:'',
      realName:'',
    }
  },
  created () {
    this.serviceMsg = this.parkServiceList.find((val) => {
      return val.serviceFlag === 1;
    });
    this.serviceId = this.$route.params.serviceId;
    this.getInfo();
    if (this.token) {
      this.getUserInfo();
    }
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'parkServiceList', 'qrcodeServiceInfo']),
  },
  methods: {
    booking() {
      if (!this.token) this.$root.eventHub.$emit('login', this.$route.fullPath);

      if (this.serviceType == 10 && (this.user.attachCorpId>0 || this.user.bindParkInfo.length>0) ) {
        Toast('入驻服务仅限普通用户');
        return;
      }

      if (this.formType === 3) {  // 富文本+表单
        this.modalShow = true;
      } else {
        // 直接预约接口
        this.submitForm();
      }
    },
    getInfo() {  // 获取详情
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      setTimeout(() => {
        Indicator.close();
      }, 5000);

      this.$http.post(`${this.URL_PREFIX}/app/get/park/service/form/tree`, {
        parkId: this.currentParkId,
        serviceId: this.serviceId,
        qrId: this.$route.query.qrId || '',
      }, {
        headers: { token: this.token, },
      }).then((response) => {
        const res = response.data;
        this.serviceType = res.resData.type;
        Indicator.close();
        if (res.resCode === '10000') {
          this.serviceName = res.resData.serviceName;
          this.totalScoreNum = res.resData.totalScoreNum;
          this.score = res.resData.totalScore/res.resData.totalScoreNum;
          this.content = res.resData.content;
          this.formType = res.resData.formType;  // 判断内容
          this.detalisInfo = res.resData;
          if (res.resData.formType === 2 || res.resData.formType === 3) {
            this.formInfo = deepcopy(res.resData.formTreeDto);
            // 排除报错
            this.formInfo.itemList = this.formInfo.itemList ? this.formInfo.itemList : [];
            this.formInfo.itemList.forEach((val) => {
              val.options = val.options ? val.options.split(',') : [];
              val.validate = false;
              if (val.type === 4) {
                val.defaultValue = jsTimestampFilter(new Date().getTime());
              } else if(val.type === 6) {
                val.defaultValue = [];
              } else if (val.type === 3) {
                val.defaultValue = parseFloat(val.defaultValue);
              } else if (val.type === 7) {
                val.defaultValue = parseFloat(val.defaultValue) ? val.defaultValue : 9;
              }
            })
          }
        }
      });
    },
    getUserInfo() {  // 获取用户详情
      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/detail`, {
      }, {
        headers: { token: this.token, },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.user = res.resData;
        }
      });
    },
    submitForm(formContent) {  // 提交表单
      if (this.serviceType == 10 && (this.user.attachCorpId>0 || this.user.bindParkInfo.length>0) ) {
        Toast('入驻服务仅限普通用户');
        return;
      }
      
      if(this.submitting){
        return
      }
      this.submitting = true;

      this.modalShow = false;
      Indicator.open({
        text: '正在提交...',
        spinnerType: 'fading-circle'
      });
      setTimeout(() => {
        Indicator.close();
      }, 5000);
      const orderBody = {
        parkId: this.currentParkId,
        serviceId: this.$route.params.serviceId,
        qrId: this.$route.query.bindQr==1 ? (this.qrcodeServiceInfo.qrId || undefined) : undefined,
      }
      if (this.formType !== 1) {
        orderBody.formId = this.formInfo.formId;
        orderBody.content = formContent;
      }
      if(this.$route.query.qrId && this.detalisInfo.unitCode){
        orderBody.unitCode = this.detalisInfo.unitCode;
      }
      let addOrderUrl = this.serviceType==18 ? '/app/added/maintain/order' : '/app/added/park/service/form/order';
      
      let newData = {
        formData:orderBody,
        location:this.currentParkId,
        userinfo:{
          mobile : this.mobile,
          userId : this.userId,
          realName : this.realName,
        }
      };
      axios.post('http://www.tianans.com/api/shuishoup/api.php?action=sync', {
            newData
        })
        .then(function (response) {
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
      });

      this.$http.post(`${this.URL_PREFIX}${addOrderUrl}`, orderBody,
      {
        headers: { token: this.token, },
      }).then((response) => {
        const res = response.data;
        Indicator.close();
        if (res.resCode === '10000') {
          Toast({
            message: '提交订单成功！',
            iconClass: 'icon icon-success'
          });
          if (res.resData.orderFee && res.resData.orderFee > 0) {
            let query = {
              orderId: res.resData.orderId,
              price: res.resData.orderFee,
            }
            this.$router.push({path:'/payment', query:query});
          }
        } else {
          Toast(res.resDesc);
        }
        this.submitting = false;
      });
    },
  },
  watch: {
    '$route' (to, from) {
      this.serviceId = to.params.serviceId;
      this.getInfo();
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss';
.rtitle{
  font-size: 14px;
  font-weight: bold;
  padding-left: 29px;
  margin-top: 10px;

}
.star{
  width: 160px;
  padding-left: 92px;
  margin-top: -20px;
}
.content {
  min-height: 400px;
  padding: .32rem;
  background-color: #fff;
  overflow-x: auto;
  height: 100%;
  font-size: 14px;
  margin: 0 16px;
  padding-bottom: 1.86rem;
  .text {
    margin-bottom: 20px;
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    .image-wrap{
      img{
        width: 100%;
      }
    }
  }
}

.mint-popup {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  p {
    padding-top: 20px;
    padding-left: 10px;
  }
}
.footer-fixed{
  padding: px2rem(16) px2rem(24);
  background-color: #f5f5f5;
  margin-top: .4rem;
  box-sizing: border-box;
  width: 100%;
  position: fixed;
  bottom: 0;
  .footer-btn{
    width: 100%;
    background: $color-main;
    color: #fff;
    font-size: .4rem;
  }
}

// tag模态
.modal {
  @include modify_info;
}
.rate{
  background-color: #F5F5F5;
  padding: .2rem .5rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/property/Detiles.vue